// V-CARE-05 全局提醒监听 — 认证壳内常驻轻量 WS, 到期事件实时触达:
//   · 页面在前台 → 全局 toast
//   · 页面在后台且已授权桌面通知 → Notification API
//   · 语音会话在场 (speak=true) → 交给 VoicePanel 口播 (VoiceContext 消费同事件)
// 断线指数退避重连, 页面卸载自动关闭。
import { useEffect, useRef } from 'react';
import { getToken } from '../api';
import { useNotify } from '../NotificationContext';
import { useT } from '../i18n';

export default function ReminderListener() {
  const { notifyInfo } = useNotify();
  const t = useT();
  const notifyRef = useRef(notifyInfo);
  notifyRef.current = notifyInfo;
  const tRef = useRef(t);
  tRef.current = t;

  useEffect(() => {
    const token = getToken();
    if (!token) return undefined;

    let ws = null;
    let closed = false;
    let attempts = 0;
    let timer = null;

    const wsUrl = () => {
      const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
      const base = (import.meta.env.BASE_URL || '/cortex/').replace(/\/$/, '');
      return `${proto}//${window.location.host}${base}/?token=${encodeURIComponent(token)}`;
    };

    const connect = () => {
      if (closed) return;
      try { ws = new WebSocket(wsUrl()); } catch (_) { scheduleReconnect(); return; }

      ws.onopen = () => { attempts = 0; };
      ws.onmessage = (msg) => {
        let payload;
        try { payload = JSON.parse(msg.data); } catch (_) { return; }
        if (!payload || payload.event !== 'reminder' || !payload.data) return;
        const d = payload.data;
        const title = tRef.current('care.reminder_toast_title');
        // 前台: toast; 后台且已授权: 桌面通知 (授权引导在 设置→关怀与提醒, 不主动弹权限)
        notifyRef.current(title, d.title);
        if (document.hidden && typeof Notification !== 'undefined' && Notification.permission === 'granted') {
          try { new Notification(title, { body: d.title, tag: `ozstaff-reminder-${d.id}` }); } catch (_) { /* 桌面通知失败有 toast 兜底 */ }
        }
      };
      ws.onclose = () => scheduleReconnect();
      ws.onerror = () => { try { ws && ws.close(); } catch (_) {} };
    };

    // P1-3: 函数声明(提升) — 修复 no-use-before-define (connect 回调内引用)
    function scheduleReconnect() {
      if (closed) return;
      attempts += 1;
      const delay = Math.min(30000, 1000 * Math.pow(2, Math.min(attempts, 5)));
      timer = setTimeout(connect, delay);
    }

    connect();
    return () => {
      closed = true;
      if (timer) clearTimeout(timer);
      try { ws && ws.close(); } catch (_) {}
    };
  }, []);

  return null;
}
